const wNumb = require('wnumb')
const Decimal = require('decimal.js')

const formater = wNumb({
  mark: '.',
  thousand: ',',
  decimals: 2,
  prefix: '¥ '
})
const formater2 = wNumb({
  mark: '',
  thousand: ',',
  decimals: 0,
  prefix: ''
})
const formater3 = wNumb({
  mark: '.',
  thousand: ',',
  decimals: 2,
  prefix: ''
})

export function toMoney (number) {
  let moneyNumber = Number(number)
  if (Number.isNaN(moneyNumber)) {
    moneyNumber = 0
  }
  return formater.to(moneyNumber)
}

export function toNumber (number) {
  let moneyNumber = Number(number)
  if (Number.isNaN(moneyNumber)) {
    moneyNumber = 0
  }
  return formater2.to(moneyNumber)
}

export function toMoneyNoPrefix (number) {
  let moneyNumber = Number(number)
  if (Number.isNaN(moneyNumber)) {
    moneyNumber = 0
  }
  return formater3.to(moneyNumber)
}

export function toMoneyPreserveDecimals (value) {
  if (value === null || value === undefined || value === '') {
    return formater.to(0)
  }
  let d
  try {
    d = new Decimal(value)
  } catch (e) {
    return formater.to(0)
  }
  if (d.isNaN() || !d.isFinite()) {
    return formater.to(0)
  }
  const negative = d.isNegative()
  const s = d.abs().toString()
  const parts = s.split('.')
  const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const frac = parts.length > 1 ? '.' + parts[1] : ''
  return '¥ ' + (negative ? '-' : '') + intFormatted + frac
}
